import { Component, OnInit, Input } from '@angular/core';
import { Router, NavigationEnd, RouterState } from '@angular/router';
import { SubmissionType } from 'app/domain/data-access-interfaces/academic-report-submission.service';

@Component({
	selector: 'section-header',
	templateUrl: './section-header.component.html',
	styleUrls: ['./section-header.component.scss']
})
export class SectionHeaderComponent implements OnInit {
	@Input() sectionTitle: string;
	@Input() navPath: string;
	/** Optional override for the section-title link. Defaults to navPath.
	 *  Lets the title route somewhere other than the tab-active base path. */
	@Input() titleLink: string;
	@Input() navLinks: any[];
	@Input() containerClass: string = "container";
	private activeRoute: RouterState | null = null;
	public SubmissionType = SubmissionType; 
	menuOpen: boolean = false;

	constructor(private router: Router) { 
		router.events.subscribe(e => {
			if(NavigationEnd.prototype.isPrototypeOf(e)){
				this.activeRoute = router.routerState;
			}
		});
	}

	ngOnInit() {
	}

	urlIsActive(url: string){
		if(!this.activeRoute){
			return false;
		}
		return this.activeRoute.snapshot.url.indexOf(this.navPath + '/' + url) == 0;
	}

}